export const SUPPORTED_LANGUAGES = [
  { code: "es", label: "Español", antdLocale: "es_ES" },
  { code: "en", label: "English", antdLocale: "en_US" },
];

export const DEFAULT_LANGUAGE = "es";
export const FALLBACK_LANGUAGE = "es";
export const NAMESPACES = [
  "common",
  "auth",
  "institutions",
  "plans",
  "dashboard",
  "scenes",
  "teachers",
  "students",
  "assistants",
  "evaluations",
  "support",
  "billing",
  "partners",
  "users",
  "tasks",
  "itineraries",
  "training",
];
export const DEFAULT_NAMESPACE = "common";
